import React from 'react';
import {
  CREDIT_MODEL_COPY,
  formatDate,
  getPlanningCredits,
  isSubscriptionActive
} from '../utils/billing';

const BillingSummary = ({
  user,
  compact = false,
  onBuyCredits,
  onManageSubscription,
  onViewPlans
}) => {
  const billing = user?.billing || {};
  const credits = getPlanningCredits(user);
  const active = isSubscriptionActive(user);
  const periodEnd = formatDate(billing.current_period_end);
  const monthlyAllowance = Number(billing.monthly_credit_allowance || 0);

  const sectionClass = compact
    ? 'rounded-2xl border border-stone-200 bg-gradient-to-br from-stone-50 via-white to-stone-100/50 p-4 sm:p-5 shadow-sm relative overflow-hidden'
    : 'rounded-2xl border border-stone-200 bg-gradient-to-br from-white to-stone-50/50 p-5 sm:p-6 shadow-sm relative overflow-hidden';

  return (
    <section className={sectionClass}>
      <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
        <div>
          <p className={`text-xs font-bold uppercase tracking-[0.14em] ${compact ? 'text-stone-600' : 'text-stone-700'}`}>
            Credits & subscription
          </p>
          <h2 className={`${compact ? 'text-xl' : 'text-2xl'} font-extrabold text-gray-950 mt-1`}>
            {credits} planning credit{credits === 1 ? '' : 's'}
          </h2>
          <p className="mt-2 max-w-2xl text-sm leading-relaxed text-gray-600">{CREDIT_MODEL_COPY}</p>
        </div>

        <div className={`rounded-xl px-4 py-3 text-sm text-gray-700 sm:min-w-[220px] ${compact ? 'bg-white/85 ring-1 ring-stone-100' : 'bg-stone-50'}`}>
          <div className="flex items-center justify-between gap-3">
            <span className="font-semibold">Subscription</span>
            <span className={`rounded-full px-2.5 py-1 text-xs font-bold ${active ? 'bg-emerald-100 text-emerald-700' : 'bg-gray-200 text-gray-600'}`}>
              {active ? 'Active' : 'Not active'}
            </span>
          </div>
          {active && (
            <p className="mt-2 text-xs leading-relaxed text-gray-500">
              {monthlyAllowance || 2} credits added monthly. Unused credits roll over.
              {periodEnd ? ` Current period ends ${periodEnd}.` : ''}
            </p>
          )}
        </div>
      </div>

      <div className="mt-5 flex flex-wrap gap-2 sm:gap-3 items-center">
        <button
          type="button"
          onClick={onBuyCredits}
          className="inline-flex h-9 sm:h-11 items-center justify-center rounded-xl bg-zinc-900 px-3 sm:px-5 text-sm font-bold text-white shadow-sm transition hover:bg-zinc-800"
        >
          Buy credits
        </button>
        {active ? (
          <button
            type="button"
            onClick={onManageSubscription}
            className="inline-flex h-9 sm:h-11 items-center justify-center rounded-xl border border-gray-300 bg-white px-3 sm:px-5 text-sm font-bold text-gray-800 transition hover:bg-gray-50"
          >
            Manage or cancel subscription
          </button>
        ) : (
          <button
            type="button"
            onClick={onViewPlans || onBuyCredits}
            className="inline-flex h-9 sm:h-11 items-center justify-center rounded-xl border border-gray-300 bg-white px-3 sm:px-5 text-sm font-bold text-gray-800 transition hover:bg-gray-50"
          >
            See subscription options
          </button>
        )}
      </div>
    </section>
  );
};

export default BillingSummary;
